import React, { createContext, useEffect, useState } from 'react';
import {
  getActionItemCollection,
  getGoalCollection,
  getMeetingCollection,
} from 'Components/UI/ContextMenu/utils';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import PropTypes from 'prop-types';

const ContextMenuContext = createContext(undefined);

const ContextMenuProvider = ({ children }) => {
  const [context, setContext] = useState({});
  const { householdResource } = useSimpleHousehold();

  const collectGoalCollection = async (contextObject) => {
    // eslint-disable-next-line no-param-reassign
    contextObject.goalCollection = await getGoalCollection(householdResource);
  };
  const collectActionItemCollection = async (contextObject) => {
    // eslint-disable-next-line no-param-reassign
    contextObject.actionItemCollection = await getActionItemCollection(householdResource);
  };
  const collectMeetingCollection = async (contextObject) => {
    // eslint-disable-next-line no-param-reassign
    contextObject.meetingCollection = await getMeetingCollection(householdResource);
  };

  const dispatch = async () => {
    if (householdResource?.id()) {
      const contextObject = {};
      // Mutate contextObject with pass-by-reference so we only have to set state (and re-render) once
      await Promise.all([
        collectGoalCollection(contextObject),
        collectActionItemCollection(contextObject),
        collectMeetingCollection(contextObject),
      ]);
      setContext(contextObject);
    }
  };

  useEffect(() => {
    dispatch();
  }, [householdResource?.id()]);

  return (
    <ContextMenuContext.Provider value={{ ...context, dispatch }}>
      {children}
    </ContextMenuContext.Provider>
  );
};

ContextMenuProvider.propTypes = {
  children: PropTypes.object.isRequired,
};

export function useContextMenuContext() {
  const context = React.useContext(ContextMenuContext);

  if (context === undefined) {
    throw new Error('useContextMenuContext must be used within a ContextMenuProvider');
  }

  return context;
}

const ProviderWrapper = ({ children }) => {
  return (
    <ContextMenuProvider>
      {children}
    </ContextMenuProvider>
  );
};

ProviderWrapper.propTypes = {
  children: PropTypes.object.isRequired,
};

export default ProviderWrapper;
